import { FormUnit } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import { useSegment } from '@/modules/analytics'
import {
  FormContent,
  StepContainer,
  StepFooter,
  StepHeader,
} from '@/modules/yearlyCheck/components/steps/components'
import { useStepper } from '@/modules/yearlyCheck/hooks/useStepper'
import { useSaveAssessmentStep } from '@/pages/SelfAssessmentPage/helpers'
import { FormProvider, useFormContext } from '@/providers'
import { useTranslation } from 'react-i18next'
import {
  ValidationSchemaMessages,
  makeLastYearFinancesValidationSchema,
} from '../../helpers/validationSchema'

const LastYearFinancesForm = () => {
  const { onNext } = useStepper()
  const { values } = useFormContext()
  const { t } = useTranslation()
  const analytics = useSegment()
  const { save, isLoading: isButtonLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.lastYearFinances,
    undefined,
    true,
  )
  const handleOnChange = () => {
    if (!values) return

    save().then(async () => {
      await analytics.track('user_app_yearly_check_last_year_finances')
      onNext(AssessmentStepKeys.lastYearFinances, values)
    })
  }

  return (
    <>
      <StepHeader
        sectionLabel={t('yearlyAssessment.lastYearFinances-category')}
        title={t('yearlyAssessment.lastYearFinances-title')}
      />
      <FormContent>
        <FormUnit
          label={t('yearlyAssessment.lastYearFinancesApproxTurnover')}
          name="approxTurnover"
          placeholder="200.000"
          unit="€"
        />
        <FormUnit
          label={t('yearlyAssessment.lastYearFinancesApproxPersonelExpenses')}
          name="approxPersonelExpenses"
          placeholder="100.000"
          unit="€"
        />
      </FormContent>
      <StepFooter isButtonLoading={isButtonLoading} onSubmit={handleOnChange} />
    </>
  )
}

export const LastYearFinances = () => {
  const { formValues } = useStepper()
  const { t } = useTranslation()
  const validations: ValidationSchemaMessages = t('validations', {
    returnObjects: true,
  })

  return (
    <StepContainer>
      <FormProvider
        initialValues={{
          approxPersonelExpenses:
            formValues.last_year_finances?.approxPersonelExpenses,
          approxTurnover: formValues.last_year_finances?.approxTurnover,
        }}
        validationSchema={makeLastYearFinancesValidationSchema(validations)}
      >
        <LastYearFinancesForm />
      </FormProvider>
    </StepContainer>
  )
}
